<app-header></app-header>

<div class="login-page">
  <div class="page-body">

    <!-- LEFT PANEL -->
    <section class="left">
      <div class="shimmer"></div>
      <div class="pts" aria-hidden="true"></div>
      <div class="left-in">
        <div class="brand-top">
          <img class="brand-logo" src="../../assets/NEXGEN Logo final for footer.png"
            alt="NexGen Executive Coaching Academy Logo" routerLink="/home" />
        </div>

        <h1 class="l-h1">
          Staff access.<br />
          <em>Admin &amp; Instructors</em>
        </h1>

        <p class="l-body">
          Manage sessions, students, content, and reports.<br />
          <strong>Select your role and log in to continue.</strong>
        </p>

        <div class="steps">
          <div class="step">
            <div class="sn">1</div>
            <div class="st"><strong>Select a role</strong> — Admin or Instructor</div>
          </div>
          <div class="step">
            <div class="sn">2</div>
            <div class="st"><strong>Enter your staff email</strong> and password</div>
          </div>
          <div class="step">
            <div class="sn">3</div>
            <div class="st"><strong>Verify with a code</strong> — sent to your email for security</div>
          </div>
        </div>

        <div class="l-foot">
          Need help getting in?<br />
          Email us: <a href="mailto:support@nexgencoaches.com">support@nexgencoaches.com</a>
        </div>
      </div>
    </section>

    <!-- RIGHT PANEL -->
    <section class="right">
      <div class="fw">

        <div class="fey">Staff Login</div>

        <h2 class="fh2">
          Log in to<br />
          <em>{{ role === 'admin' ? 'Admin Dashboard' : 'Instructor Dashboard' }}.</em>
        </h2>

        <p class="fsub">Select your role, then enter your credentials.</p>

        <!-- ROLE SELECT -->
        <div class="staff-sep">Select role</div>
        <div class="staff-box">
          <div class="staff-note">Choose how you want to log in</div>
          <div class="staff-btns">
            <button type="button" class="btn-staff" [class.active]="role==='admin'" (click)="setRole('admin')">Admin</button>
            <button type="button" class="btn-staff" [class.active]="role==='instructor'" (click)="setRole('instructor')">Instructor</button>
          </div>
        </div>

        <!-- FORM -->
        <form (ngSubmit)="onLogin()" novalidate>

          <!-- EMAIL -->
          <div class="field">
            <label for="email">Staff Email Address</label>
            <input type="email" id="email" name="email" [(ngModel)]="email"
              placeholder="you@company.com" autocomplete="email" required #emailInput="ngModel"
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
              [class.err]="emailInput.invalid && (emailInput.dirty || emailInput.touched || submitted)" />
            <div class="inline-err" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched || submitted)">
              <span *ngIf="emailInput.errors?.['required']">Email address is required.</span>
              <span *ngIf="emailInput.errors?.['pattern']">Please enter a valid email address.</span>
            </div>
          </div>

          <!-- PASSWORD -->
          <div class="field">
            <label for="password">Password</label>
            <div class="pw-wrap">
              <input [type]="showPassword ? 'text' : 'password'" id="password" name="password"
                [(ngModel)]="password" placeholder="Enter your password"
                autocomplete="current-password" required #passwordInput="ngModel"
                [class.err]="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched || submitted)" />
              <button type="button" class="pw-eye" aria-label="Toggle password visibility"
                (click)="togglePasswordVisibility('password')">
                <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
            <div class="inline-err" *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched || submitted)">
              Password is required.
            </div>
          </div>

          <!-- META -->
          <div class="meta">
            <label class="rem">
              <input type="checkbox" id="rememberMe" name="rememberMe" [(ngModel)]="rememberMe" />
              <span>Remember me</span>
            </label>
            <a routerLink="/forgot-password" class="fgt">Forgot Password?</a>
          </div>

          <!-- SUBMIT -->
          <button type="submit" class="btn-login" [disabled]="isOtpSending">
            <span *ngIf="!isOtpSending">Log In as {{ role === 'admin' ? 'Admin' : 'Instructor' }}</span>
            <span *ngIf="isOtpSending" class="btn-spinner-row">
              <span class="btn-spinner btn-spinner--light"></span> Sending code…
            </span>
          </button>
          <div class="gold-bar"></div>

        </form>

        <div class="help-row">
          Student login?&nbsp;
          <a routerLink="/login">Go to Student Login →</a>
        </div>

      </div>
    </section>

  </div>
</div>

<!-- ===================== OTP MODAL ===================== -->
<div class="otp-overlay" *ngIf="showOtpModal" (click)="closeOtpModal()">
  <div class="otp-modal" (click)="$event.stopPropagation()">

    <div class="otp-modal-bar"></div>

    <!-- Close — inline SVG X -->
    <button class="otp-modal-close" type="button" (click)="closeOtpModal()" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <div class="otp-modal-body">

      <!-- Envelope — inline SVG -->
      <div class="otp-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>

      <div class="otp-eyebrow">Two-Step Verification</div>
      <h3 class="otp-heading">Check your inbox</h3>

      <p class="otp-sub">
        We sent a 6-digit verification code to<br />
        <strong>{{ email }}</strong>
      </p>

      <!-- 6 STATIC inputs -->
      <div class="otp-inputs" [class.otp-shake]="otpShake">
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-0"
          (keydown)="onOtpKeyDown($event, 0)" (paste)="onOtpPaste($event)" />
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-1"
          (keydown)="onOtpKeyDown($event, 1)" (paste)="onOtpPaste($event)" />
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-2"
          (keydown)="onOtpKeyDown($event, 2)" (paste)="onOtpPaste($event)" />
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-3"
          (keydown)="onOtpKeyDown($event, 3)" (paste)="onOtpPaste($event)" />
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-4"
          (keydown)="onOtpKeyDown($event, 4)" (paste)="onOtpPaste($event)" />
        <input class="otp-box" type="text" inputmode="numeric" maxlength="1"
          autocomplete="one-time-code" id="otp-5"
          (keydown)="onOtpKeyDown($event, 5)" (paste)="onOtpPaste($event)" />
      </div>

      <!-- Error — inline SVG exclamation -->
      <div class="otp-err" *ngIf="otpError">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ otpError }}
      </div>

      <button class="otp-verify-btn" type="button"
        (click)="verifyOtpAndLogin()"
        [disabled]="isOtpVerifying || otpDigits.join('').length < 6">
        <span *ngIf="!isOtpVerifying">Verify &amp; Log In</span>
        <span *ngIf="isOtpVerifying" class="btn-spinner-row">
          <span class="btn-spinner btn-spinner--dark"></span> Verifying…
        </span>
      </button>

      <div class="otp-resend-row">
        <span class="otp-resend-label">Didn't get the code?</span>
        <button type="button" class="otp-resend-btn" (click)="resendOtp()"
          [disabled]="resendRemaining > 0 || isOtpSending">
          <span *ngIf="resendRemaining > 0">Resend in {{ resendRemaining }}s</span>
          <span *ngIf="resendRemaining === 0 && !isOtpSending">Resend code</span>
          <span *ngIf="isOtpSending" class="btn-spinner-row">
            <span class="btn-spinner"></span> Sending…
          </span>
        </button>
      </div>

      <!-- Lock — inline SVG -->
      <p class="otp-note">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        This code expires in 15 minutes. Check your spam folder if needed.
      </p>

    </div>
  </div>
</div>

<app-bottomside></app-bottomside>